// extracted by mini-css-extract-plugin
export var headerCell = "_5h-1";
export var loadingSpinnerContainer = "_5h-4";
export var rowWrapper = "_5h-3";
export var standaloneTable = "_5h-5";
export var table = "_5h-0";
export var white = "_5h-2";